// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.table-scrollable {
  overflow: auto;
  max-height: 90vh;
  overflow-x: hidden;
}

.production_column {
  position: relative;
  position: sticky;
  left: 0;
  top: 0;
  z-index: 4;
  background-color: white !important;
}

.production_column::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 1px;
  height: 100%;
  background-color: #dee2e6;
}

.production__eye img {
  width: 25px;
  height: 25px;
  cursor: pointer;
}

.thead_column {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white !important;
}

.thead_column::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
}

.button__production {
  width: 190px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}
.button__production.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff; /* Белый текст для активной кнопки */
}
@media (max-width: 460px) {
  .button__production {
    width: 120px;
    height: 20px;
    font-size: 10px;
    margin-right: 5px;
  }
}
.button__production-active {
  width: 150px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}
.button__production-active.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff; /* Белый текст для активной кнопки */
}
@media (max-width: 460px) {
  .button__production-active {
    width: 60px;
    height: 20px;
    font-size: 10px;
    margin-right: 5px;
  }
}
.button__production-noactive {
  width: 150px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}
.button__production-noactive.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff; /* Белый текст для активной кнопки */
}
@media (max-width: 460px) {
  .button__production-noactive {
    width: 80px;
    height: 20px;
    font-size: 10px;
    margin-right: 5px;
  }
}

.inactive {
  background-color: #ffffff; /* Белый фон для неактивной кнопки */
  color: #212529; /* Черный текст для неактивной кнопки */
}

.production__search {
  height: 30px;
  width: 100px;
  font-size: 14px;
  outline: none;
}
@media (max-width: 460px) {
  .production__search {
    width: 60px;
    height: 20px;
    font-size: 10px;
  }
}

.production-table-container {
  position: relative;
  margin-top: 20px;
  overflow: hidden;
  height: calc(100vh - var(--header-height, 150px));
}
@media (max-width: 768px) {
  .production-table-container {
    height: calc(100vh - var(--header-height, 250px));
  }
}

.production-table-wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.production-th {
  padding: 5px !important;
  position: sticky;
  left: 0;
  top: 0;
  z-index: 3;
  text-align: center;
  width: 25px;
}

.production-th.stat {
  background-color: #ffffff !important;
}

.production-th::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  border-bottom: 2px solid #000000;
  width: 100%;
}

.production-th.mobile {
  padding: 5px !important;
  position: sticky;
  left: 0;
  top: 0;
  z-index: 4;
  background-color: white !important;
  text-align: center;
  width: 50px;
}

.production-th.mobile::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
}

.production__td.mobile {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 3;
  background-color: white !important;
}

.production__td.mobile::after {
  content: "";
  position: absolute;
  top: 0px;
  right: 0px;
  width: 1px;
  height: 100%;
  background-color: #000000;
}

.production__td.production {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 3;
  background-color: white !important;
}

.production__td.production::after {
  content: "";
  position: absolute;
  top: 0px;
  right: 0px;
  width: 1px;
  height: 100%;
}

.production-table__thead {
  border-color: transparent;
}

.production-table__tbody {
  border: 2px solid #000000;
}

.production-table__row {
  border-width: 0px !important;
}

.production-detail {
  font-size: 17px;
  color: #000000;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
}

.production-detailShipment {
  font-size: 15px;
  color: #dee2e6;
  font-weight: 400;
  text-align: center;
  cursor: pointer;
}

.production-detailDelivery {
  font-size: 15px;
  color: #dee2e6;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/ProductionList/styles.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;AAEJ;;AAEE;EACE,kBAAA;EACA,gBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,kCAAA;AACJ;;AAGA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AAAJ;;AAQI;EACI,WAAA;EACA,YAAA;EACA,eAAA;AALR;;AASA;EACI,gBAAA;EACA,MAAA;EACA,UAAA;EACA,kCAAA;AANJ;;AAWA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EAEA,YAAA;EAEA,WAAA;AAVJ;;AAcA;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAXJ;AAYI;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA,EAAA,oCAAA;AAVR;AAYI;EAfJ;IAgBQ,YAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EATN;AACF;AAWI;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AATR;AAUQ;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA,EAAA,oCAAA;AARZ;AAUQ;EAfJ;IAgBQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAPV;AACF;AAUI;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AARR;AASQ;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA,EAAA,oCAAA;AAPZ;AASQ;EAfJ;IAgBQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EANV;AACF;;AAUA;EACI,yBAAA,EAAA,oCAAA;EACA,cAAA,EAAA,uCAAA;AAPJ;;AAUA;EACI,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AAPJ;AAQI;EALJ;IAMQ,WAAA;IACA,YAAA;IACA,eAAA;EALN;AACF;;AASA;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iDAAA;AANJ;AAOI;EALJ;IAMQ,iDAAA;EAJN;AACF;;AAOA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,iCAAA;EAEA,4BAAA;AALJ;;AAaA;EACI,uBAAA;EACA,gBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;AAVJ;;AAcA;EACI,oCAAA;AAXJ;;AAcA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,gCAAA;EACA,WAAA;AAXJ;;AAeA;EACI,uBAAA;EACA,gBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,kCAAA;EACA,kBAAA;EACA,WAAA;AAZJ;;AAeA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EAEA,WAAA;AAbJ;;AAgBA;EACI,gBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,kCAAA;AAbJ;;AAiBA;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AAdJ;;AAmBA;EACI,gBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,kCAAA;AAhBJ;;AAqBA;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;AAlBJ;;AAwBA;EACI,yBAAA;AArBJ;;AAwBA;EACI,yBAAA;AArBJ;;AAwBA;EACC,4BAAA;AArBD;;AAwBA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AArBJ;;AAwBA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AArBJ;;AAwBA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AArBJ","sourcesContent":[".table-scrollable {\n    overflow: auto;\n    max-height: 90vh;\n    overflow-x: hidden;\n  }\n\n  \n  .production_column {\n    position: relative;\n    position: sticky;\n    left: 0;\n    top: 0;\n    z-index: 4;\n    background-color: white !important; \n  \n    }\n\n.production_column::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 1px;\n    height: 100%;\n    background-color: #dee2e6; \n    // border-bottom: 1px solid #dee2e6 !important; \n  }\n\n\n\n\n.production__eye {\n    img {\n        width: 25px;\n        height: 25px;\n        cursor: pointer;\n    }\n}\n\n.thead_column {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    background-color: white !important; \n  \n}\n\n\n.thead_column::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n   \n    height: 100%;\n    // border-bottom: 2px solid #dee2e6; \n    width: 100%;\n    \n  }\n\n.button__production {\n    width: 190px;\n    height: 30px;\n    border: 1px solid #212529;\n    background-color: #212529;\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    margin-right: 10px;\n    &.active {\n        background-color: #212529; /* Черный фон для активной кнопки */\n        color: #ffffff; /* Белый текст для активной кнопки */\n    }\n    @media(max-width: 460px) {\n        width: 120px;\n        height: 20px;\n        font-size: 10px;\n        margin-right: 5px;\n    }\n\n    &-active {\n        width: 150px;\n        height: 30px;\n        border: 1px solid #212529;\n        background-color: #212529;\n        color: #ffffff;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 14px;\n        margin-right: 10px;\n        &.active {\n            background-color: #212529; /* Черный фон для активной кнопки */\n            color: #ffffff; /* Белый текст для активной кнопки */\n        }\n        @media(max-width: 460px) {\n            width: 60px;\n            height: 20px;\n            font-size: 10px;\n            margin-right: 5px;\n        }\n    }\n\n    &-noactive {\n        width: 150px;\n        height: 30px;\n        border: 1px solid #212529;\n        background-color: #212529;\n        color: #ffffff;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 14px;\n        margin-right: 10px;\n        &.active {\n            background-color: #212529; /* Черный фон для активной кнопки */\n            color: #ffffff; /* Белый текст для активной кнопки */\n        }\n        @media(max-width: 460px) {\n            width: 80px;\n            height: 20px;\n            font-size: 10px;\n            margin-right: 5px;\n        }\n    }\n}\n\n.inactive {\n    background-color: #ffffff; /* Белый фон для неактивной кнопки */\n    color: #212529; /* Черный текст для неактивной кнопки */\n}\n\n.production__search {\n    height: 30px;\n    width: 100px;\n    font-size: 14px;\n    outline: none; \n    @media(max-width: 460px) {\n        width: 60px;\n        height: 20px;\n        font-size: 10px;\n    }\n}\n\n\n.production-table-container {\n    position: relative;\n    margin-top: 20px; \n    overflow: hidden;\n    height: calc(100vh - var(--header-height, 150px));\n    @media(max-width: 768px) {\n        height: calc(100vh - var(--header-height, 250px));\n    }\n}\n  \n.production-table-wrapper {\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    -webkit-overflow-scrolling: touch;\n    // border: 1px solid #dee2e6;\n    overscroll-behavior: contain;\n \n   \n  \n}\n\n\n    \n.production-th {\n    padding: 5px !important;\n    position: sticky;\n    left: 0;\n    top: 0;\n    z-index: 3;\n    text-align: center;\n    width: 25px;\n   \n}\n\n.production-th.stat {\n    background-color: #ffffff !important;\n}\n\n.production-th::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    border-bottom: 2px solid #000000;\n    width: 100%;  \n}\n\n\n.production-th.mobile {\n    padding: 5px !important;\n    position: sticky;\n    left: 0;\n    top: 0;\n    z-index: 4;\n    background-color: white !important; \n    text-align: center;\n    width: 50px;\n}\n\n.production-th.mobile::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    // border-bottom: 2px solid #dee2e6;\n    width: 100%;\n}\n\n.production__td.mobile {\n    position: sticky;\n    left: 0;\n    top: 0;\n    z-index: 3;\n    background-color: white !important; \n    \n}\n\n.production__td.mobile::after {\n    content: '';\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    width: 1px;\n    height: 100%;\n    background-color: #000000; \n \n        \n}\n\n.production__td.production {\n    position: sticky;\n    left: 0;\n    top: 0;\n    z-index: 3;\n    background-color: white !important; \n    \n    \n}\n\n.production__td.production::after {\n    content: '';\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    width: 1px;\n    height: 100%;\n    // background-color: #dee2e6; \n   \n        \n}\n\n.production-table__thead {\n    border-color: transparent;\n}\n\n.production-table__tbody {\n    border: 2px solid #000000;\n}\n\n.production-table__row{\n border-width: 0px !important;\n}\n\n.production-detail {\n    font-size: 17px;\n    color: #000000;\n    font-weight: 600;\n    text-align: center;\n    cursor: pointer;\n}\n\n.production-detailShipment {\n    font-size: 15px;\n    color: #dee2e6;\n    font-weight: 400;\n    text-align: center;\n    cursor: pointer;\n}\n\n.production-detailDelivery {\n    font-size: 15px;\n    color: #dee2e6;\n    font-weight: 600;\n    text-align: center;\n    cursor: pointer;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
